<mat-sidenav-container class="app-container">
  <mat-sidenav #drawer class="app-sidenav" [mode]="'over'">
    <app-side-nav
      [authResolved]="authResolved()"
      [isAuthenticated]="isAuthenticated()"
      [isAdmin]="isAdmin()"
      [userEmail]="user()?.email || null"
      (logout)="logout()"
      (navAction)="drawer.mode === 'over' ? drawer.close() : null"
    />
  </mat-sidenav>

  <mat-sidenav-content>
    <div class="app-content">
      <mat-toolbar class="app-toolbar">
        <button
          type="button"
          mat-icon-button
          class="menu-button"
          (click)="drawer.toggle()"
          aria-label="Toggle sidenav"
        >
          <mat-icon>menu</mat-icon>
        </button>
        <a class="brand" routerLink="/">{{ title() }}</a>
        <nav class="top-nav">
          <app-top-nav
            [authResolved]="authResolved()"
            [isAuthenticated]="isAuthenticated()"
            [isAdmin]="isAdmin()"
            (logout)="logout()"
          />
        </nav>
      </mat-toolbar>

      <main class="content" [@routeFadeSlide]="prepareRoute(outlet)">
        <router-outlet #outlet="outlet"></router-outlet>
      </main>

      <app-footer [year]="year" />
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
